import React from 'react';
import { motion } from 'framer-motion';
import { FaCalendarAlt, FaMapMarkerAlt } from 'react-icons/fa';
import './Education.css';

const education = [
  {
    code: 'EDU-01',
    school: 'Sunway College',
    location: 'Maitidevi, Nepal',
    degree: 'BSc (Hons) Computer and Data Science',
    period: '2023 – 2026',
    coursework: [
      'Machine Learning',
      'Deep Learning',
      'Natural Language Processing',
      'Data Analysis',
      'REST API Development',
      'AWS',
    ],
  },
];

const Education = () => {
  return (
    <section id="education" className="education">
      <div className="container">
        <div className="section-header">
          <span className="section-label">[ 05 // ACADEMIC BACKGROUND ]</span>
          <h2 className="section-title">Education</h2>
          <p className="section-subtitle">
            Formal computer and data science education combined with rigorous machine learning coursework.
          </p>
        </div>

        <div className="education__grid">
          {education.map((edu, idx) => (
            <motion.div
              className="education__card"
              key={idx}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: idx * 0.1 }}
            >
              <div className="education__header-row">
                <span className="education__code">[{edu.code}]</span>
                <span className="education__period">
                  <FaCalendarAlt /> {edu.period}
                </span>
              </div>

              <div className="education__info">
                <h3 className="education__school">{edu.school}</h3>
                <div className="education__location">
                  <FaMapMarkerAlt /> {edu.location}
                </div>
                <h4 className="education__degree">{edu.degree}</h4>

                <div className="education__coursework">
                  <span className="education__coursework-label">
                    Relevant Coursework:
                  </span>
                  <div className="education__tags">
                    {edu.coursework.map((c) => (
                      <span className="tag" key={c}>
                        {c}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
